import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';
import { getEditorScrollStyles } from '../../../Editor/styles';
import { MIN_WIDTH, MAX_WIDTH } from '../../../../containers/Editor/reducer/thumbnails';

interface InnerProps {
	isDisplayed: boolean;
}

const Wrapper = styled('div')`
	position: relative;
	display: flex;
	background-color: ${NewStyleColor.Grey900};
`;

const Inner = styled('div')`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	min-width: ${MIN_WIDTH}px;
	max-width: ${MAX_WIDTH}px;
	overflow: hidden;
	visibility: ${({ isDisplayed }: InnerProps) => isDisplayed ? 'visible' : 'hidden'};
`;

const List = styled('ul')`
	flex: 1 1 auto;
	margin: 0;
	padding: 0;
	list-style-type: none;
	overflow-x: hidden;
	overflow-y: auto;

	${getEditorScrollStyles()}
`;

export {
	Wrapper,
	Inner,
	List,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Column/styles.ts